export const FEEDBACK_SURVEY_ID = '01a0d492-7e77-0000-9928-686da05c78e9';
export const FEEDBACK_COOLDOWN_MS = 24 * 60 * 60 * 1000;

export function feedbackCooldownRemaining(completedAt: number | null, now: number): number {
  if (completedAt === null || !Number.isFinite(completedAt) || completedAt <= 0 || completedAt > now) return 0;
  return Math.max(0, completedAt + FEEDBACK_COOLDOWN_MS - now);
}

export function isFeedbackCompletion(event: { event: string; properties: Record<string, unknown> } | null): boolean {
  return event?.event === 'survey sent' && event.properties.$survey_id === FEEDBACK_SURVEY_ID && event.properties.$survey_completed === true;
}

/** The SDK has already checked URL, identity, and targeting conditions. */
export function hasFeedbackSurvey(surveys: readonly { id: string; type: string; start_date?: string | null; end_date?: string | null; archived?: boolean }[]): boolean {
  return surveys.some(survey => survey.id === FEEDBACK_SURVEY_ID && survey.type === 'api' && Boolean(survey.start_date) && !survey.end_date && !survey.archived);
}
